<template>
  <v-main class="grey lighten-3">

    <material-notification
      v-if="$store.state.auth.default_user"
      class="pt-1 pb-1 px-3"
      color="warning"
      elevation="0"
      tile
      style="position: fixed; top: 0; width: 100%; z-index: 100; opacity: 85%; color: black; zoom: 0.85"
    >
      You logged as {{ $store.state.auth.user.settings.name }} ({{ $store.state.auth.user.login }}),
      <a
        style="cursor: pointer; font-weight: bold; color: #212121"
        @click="loginAs()"
      >click to return</a> to your base account {{ $store.state.auth.default_user.settings.name }} ({{ $store.state.auth.default_user.login }})
    </material-notification>
    <div id="core-view" :class="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm' ? 'nopadding' : ''" :style="{'padding-top': !$store.state.auth.default_user ? 0 : '24px'}">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
  </v-main>
</template>

<style>
  #core-view.nopadding > .container {
    padding: 0px !important;
  }
</style>

<script>
  import { API } from '@/utils/api'

  export default {
    name: 'CoreView',

    metaInfo () {
      return {
        title: this.$store.state.app.title || 'Advabet CRM'
      }
    },

    methods: {
      loginAs () {

        return API.call('/kiosk/users/login_as.json', {}, null, null).then(resp => {

          this.$notification.show = true
          this.$notification.message = `You have successfully login as ${resp.user.settings.name} (${resp.user.login})`
          this.$notification.type = 'success'

          return this.$store.dispatch('auth/checkSession', {})
        }).catch(e => {
        }).finally(() => {
          this.loading = false
        })
      },
    }
  }
</script>
